import { action } from "../common/Action"
import { CaldaieClient } from "../generated";

const service = new CaldaieClient();

class TipiCombustibileActions {
    @action
    async getAll() {
        return (await service.getTipiCombustibile())!;

    };
}
export default new TipiCombustibileActions();